import type { FC, FocusEvent } from 'react';
import NumberFormat from 'react-number-format';
import { useLocalizedNumberFormatters } from '@mwl/core-lib';
import type { CouponSumBadgeProps } from './CouponSumBadge.types';
import styles from './CouponSumBadge.module.scss';
const defaultEmptyValue = '0';
const CouponSumBadge: FC<CouponSumBadgeProps> = ({
  className,
  inputDisabled,
  value,
  onChange,
  onClick,
  maxLength
}) => {
  const {
    currencyDecimalSeparator
  } = useLocalizedNumberFormatters();
  const handleOnFocus = (event: FocusEvent<HTMLInputElement>) => {
    event.target.select();
  };
  const handleOnBlur = () => {
    if (!value) {
      onChange(defaultEmptyValue);
    }
  };
  return <button type="button" disabled={!inputDisabled} onClick={() => onClick(value)} className={cn(styles.button, {
    [styles.editableButton]: !inputDisabled
  }, className)} data-sentry-component="CouponSumBadge" data-sentry-source-file="CouponSumBadge.tsx">
      <NumberFormat value={value} onBlur={handleOnBlur} onValueChange={values => onChange(values.value)} decimalScale={0} allowNegative={false} className={cn(styles.inputField, {
      [styles.inputDisabled]: inputDisabled
    })} onFocus={handleOnFocus} isNumericString decimalSeparator={currencyDecimalSeparator} maxLength={maxLength} data-sentry-element="NumberFormat" data-sentry-source-file="CouponSumBadge.tsx" />
    </button>;
};
export { CouponSumBadge };